import { useEffect, useState, useMemo } from "react";
import { H2, H3, P } from "../../../components/typography/styled";
import { BaseButton } from "../../../components/button/styled";
import { pricing, getPlanFeatures } from "../../../config/home/pricing";
import {
  PlansAndPricingRow,
  PlansAndPricingWrapper,
  PricingCard,
  CardFeatures,
  MostPopularBadge,
} from "./styled";
import { useNavigate } from "react-router-dom";
import { getAllPlans } from "../../../utils/apis/plansandpricing/getAllPlans";
import Cookies from "universal-cookie";

export const PlansAndPricing = () => {
  const navigate = useNavigate();
  const [pricingData, setPricingData] = useState(pricing);
  const cookies = useMemo(() => new Cookies(), []);

  useEffect(() => {
    const fetchPricingPlans = async () => {
      try {
        const response = await getAllPlans();

        // Transform API response to match UI structure
        if (response && Array.isArray(response)) {
          const transformedPlans = response.map((plan) => {
            const planName =
              plan.title.charAt(0).toUpperCase() + plan.title.slice(1);
            const staticPlan = pricing.find(
              (p) => p.name.toLowerCase() === planName.toLowerCase(),
            );

            const finalFeatures = getPlanFeatures(planName || staticPlan?.name);

            return {
              name: planName || staticPlan?.name || "Plan",
              employeeLimit: plan.upperLimit,
              creditCostPerEmployee: plan.creditCostPerEmployee,
              features: finalFeatures || staticPlan?.features || [],
            };
          });
          setPricingData(transformedPlans);
        }
      } catch (error) {
        console.error("Failed to fetch pricing plans:", error);
        // Fall back to static config on error
        setPricingData(pricing);
      }
    };

    fetchPricingPlans();
  }, [cookies]);

  const handleNavigation = (destination) => {
    navigate(destination);
  };

  return (
    <PlansAndPricingWrapper id="plans">
      <div className="introduction">
        <H2>Transparent Pricing</H2>
        <P>
          Simple pay-as-you-go pricing for every stage of your payroll journey
        </P>
      </div>
      <PlansAndPricingRow tocolumn={true}>
        {pricingData.map((plan, index) => {
          const isPremium = plan.name === "Premium";
          return (
            <PricingCard key={index} isHighlighted={isPremium}>
              {isPremium && <MostPopularBadge>POPULAR</MostPopularBadge>}
              <H3>{plan.name}</H3>
              <CardFeatures isHighlighted={isPremium}>
                {plan.features.map((feature, i) => (
                  <li key={i}>{feature}</li>
                ))}
              </CardFeatures>
              <BaseButton
                width={"100%"}
                backgroundcolor={isPremium ? "var(--color-primary)" : "#FFFFFF"}
                color={isPremium ? "#FFFFFF" : "var(--color-primary)"}
                onClick={() => handleNavigation("/how")}
                style={{
                  border: isPremium ? "none" : "2px solid var(--color-primary)",
                  marginTop: "auto",
                }}
              >
                Get Started
              </BaseButton>
            </PricingCard>
          );
        })}
      </PlansAndPricingRow>
    </PlansAndPricingWrapper>
  );
};
